import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';
import Image from '../AppImage';

const UserProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Mock user data - in real app this would come from auth context
  const user = {
    name: 'María González',
    email: 'maria.gonzalez@everforce.com',
    role: 'Administrador',
    avatar: '/assets/images/user-avatar.jpg'
  };

  const menuItems = [
    { label: 'Mi Perfil', icon: 'User', action: 'profile' },
    { label: 'Configuración', icon: 'Settings', action: 'settings' },
    { label: 'Ayuda', icon: 'HelpCircle', action: 'help' },
    { label: 'Cerrar Sesión', icon: 'LogOut', action: 'logout', danger: true }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuAction = (action) => {
    setIsOpen(false);
    
    switch (action) {
      case 'profile': console.log('Navigate to profile');
        break;
      case 'settings': console.log('Navigate to settings');
        break;
      case 'help': console.log('Open help');
        break;
      case 'logout': console.log('Logout user');
        // In real app: clear auth state and redirect to login
        window.location.href = '/login';
        break;
      default:
        break;
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Profile Button */}
      <button
        onClick={toggleDropdown}
        className="flex items-center space-x-2 p-2 rounded-md hover:bg-secondary-50 transition-micro focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      >
        <div className="w-8 h-8 rounded-full overflow-hidden bg-secondary-100">
          <Image
            src={user.avatar}
            alt={user.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="hidden md:block text-left">
          <div className="text-sm font-body-medium text-text-primary">
            {user.name}
          </div>
          <div className="text-xs text-text-secondary">
            {user.role}
          </div>
        </div>
        <Icon 
          name="ChevronDown" 
          size={16} 
          className={`text-text-secondary transition-micro ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-surface rounded-lg shadow-modal border border-border z-dropdown">
          {/* User Info Header */}
          <div className="px-4 py-3 border-b border-border">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-full overflow-hidden bg-secondary-100">
                <Image
                  src={user.avatar}
                  alt={user.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-body-medium text-text-primary truncate">
                  {user.name}
                </div>
                <div className="text-xs text-text-secondary truncate">
                  {user.email}
                </div>
                <div className="text-xs text-primary font-body-medium">
                  {user.role}
                </div>
              </div>
            </div>
          </div>

          {/* Menu Items */}
          <div className="py-2">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={() => handleMenuAction(item.action)}
                className={`w-full flex items-center space-x-3 px-4 py-2 text-sm transition-micro ${
                  item.danger
                    ? 'text-error hover:bg-error-50 hover:text-error' :'text-text-secondary hover:bg-secondary-50 hover:text-text-primary'
                }`}
              >
                <Icon 
                  name={item.icon} 
                  size={16} 
                  className={item.danger ? 'text-error' : 'text-text-muted'}
                />
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfileDropdown;